import { render } from "./FriendCard-Stranger.vue?vue&type=template&id=36e46ac6"
import script from "./FriendCard-Stranger.vue?vue&type=script&lang=js"
export * from "./FriendCard-Stranger.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__